import { type NPC, type NPCDispatchProps, type SetNPCsProps } from 'src/types'

// consider adding props that last from game to game
const setNPCs = ({ NPCs }: SetNPCsProps) => NPCs

export const reducer = (NPCs: Record<string, NPC>, action: NPCDispatchProps) => {
  switch (action.type) {
    case 'SET_NPCS':
      return setNPCs(action)
    default:
      return NPCs
  }
}
